import { useEffect, useEffectEvent } from 'react';
export function useWindowEvent(event, cb, { disabled = false, capture = false, } = {}) {
    const stableCb = useEffectEvent(cb);
    useEffect(() => {
        if (disabled)
            return;
        window.addEventListener(event, stableCb, { capture });
        return () => {
            window.removeEventListener(event, stableCb, { capture });
        };
    }, [stableCb, disabled, event, capture]);
}
export function useElementEvent(ref, event, cb, { disabled = false, capture = false, } = {}) {
    const stableCb = useEffectEvent(cb);
    useEffect(() => {
        if (disabled) {
            return;
        }
        const element = ref.current;
        if (!element)
            return;
        element.addEventListener(event, stableCb, { capture });
        return () => {
            element.removeEventListener(event, stableCb, {
                capture,
            });
        };
    }, [ref, event, stableCb, disabled, capture]);
}
//# sourceMappingURL=useWindowEvent.js.map